import { render, staticRenderFns } from "./newCity.vue?vue&type=template&id=5b101176"
import script from "./newCity.vue?vue&type=script&lang=js"
export * from "./newCity.vue?vue&type=script&lang=js"
import style0 from "./newCity.vue?vue&type=style&index=0&id=5b101176&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports